<template>
  <section>
    <el-row>
        <el-col :span="24" class="toolbar">
            <el-select v-model="tixian_status" placeholder="请选择" size="small" @change="search">
                <el-option key="-1" label="全部" value="-1"></el-option>
                <el-option
                    v-for="(item, index) in tixianStatus"
                    :key="index"
                    :label="item"
                    :value="index"
                    size="small">
                </el-option>
            </el-select>
        </el-col>
    </el-row>

    <el-table :data="tableData" 
            border 
            v-loading="listLoading"
            @expand="expand"
            :row-key="getRowKeys"
            :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
            <input type="hidden" :value="scope.row.id" />
          <!--订单状态-->
          <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="账号信息" name="1">
                <el-row>
                    <el-col :offset="2" :span="2">账号：</el-col>
                    <el-col :span="4">
                        <div class="user-font">{{cardForm.card_num}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">户名：</el-col>
                    <el-col :span="4">
                        <div class="user-font">{{cardForm.card_name}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">银行名称：</el-col>
                    <el-col :span="4">
                        <div class="user-font">{{cardForm.bank}}</div>
                    </el-col>
                </el-row>
            </el-collapse-item>
            <el-collapse-item title="店铺信息" name="2">
              <el-row>
                <el-col :offset="2" :span="2">店铺名称：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.dianpu_name}}</div>
                </el-col>
                <el-col :offset="2" :span="2">公司名称：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.com_name}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">联系方式：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.tel}}</div>
                </el-col>
                <el-col :offset="2" :span="2">身份证号：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.card_num}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">开始时间：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.start_time}}</div>
                </el-col>
                <el-col :offset="2" :span="2">结束时间：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{dianpu.end_time}}</div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </template>
      </el-table-column>
      <el-table-column label="提现编号" prop="tixian_num" align="center">
      </el-table-column>
      <el-table-column label="账户余额" prop="cur_coins" align="center">
      </el-table-column>
      <el-table-column label="提现金额" prop="tixian_coins" align="center">
      </el-table-column>
      <el-table-column label="提现状态" prop="tixian_status" align="center">
        <template scope="scope">
          <div>{{tixianStatus[scope.row.tixian_status]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="提现时间" prop="create_time" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button v-if="scope.row.tixian_status == 0" :plain="true" size="small" type="info" @click="tixian(scope.row.id)">确认提现</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';
  
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 10,
        listLoading: false,
        tixian_status: '-1',
        tixianStatus: basicdata.tixianStatus,
        expands: [],
        getRowKeys(row) {
          return row.id;
        },
        activeNames: '1',
        cardForm: {},
        dianpu: {}
      }
    },
    methods: {
        //分页方法
        handleSizeChange(size) {
            this.pageSize = size;
            this.search();
        },
        handleCurrentChange(page) {
            this.page = page;
            this.search();
        },
        search() {
            this.getSearch();
        },
        getSearch() {
            this.listLoading = true;
            this.$axios.post(config.api_url + '/tixian/page/'+this.tixian_status, {
                "page": this.page,
                "size": this.pageSize,
                "query": ''
            }).then(response => {
                let data = response.data;
                if (data.state) {
                    this.total = data.count;
                    this.tableData = data.msg;
                    this.listLoading = false;
                }
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '获取数据异常，请联系管理员',
                    type: 'error'
                });
            })
        },
        tixian(id) {
            this.$confirm('确认提现？', '提示', {}).then(() => {
                //异步请求
                this.$axios.put(config.api_url + '/tixian/'+id,
                ).then(response => {
                    if (response.data.state) {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.search();
                    } else {
                        this.$message({
                            message: '提交失败，'+response.data.msg,
                            type: 'error'
                        });
                    }
                }).catch(error => {
                    console.log(error);
                    this.$message({
                        message: '提交异常，请联系管理员',
                        type: 'error'
                    });
                });
            });
        },
        // 获取提现卡
        getCard(dianpuId) {
            this.$axios.get(config.api_url + '/tixian/card/'+dianpuId
            ).then(response => {
                if (response.data.state) {
                    this.cardForm = response.data.msg;
                } else {
                    this.$message({
                        message: '获取提现卡失败，请联系管理员',
                        type: 'error'
                    });
                }
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '获取提现卡异常，请联系管理员',
                    type: 'error'
                });
            });
        },
        getDianpu(dianpuId) {
            this.$axios.get(config.api_url + '/dianpu/'+dianpuId
            ).then(response => {
                if (response.data.state) {
                    this.dianpu = response.data.msg;
                } else {
                    this.$message({
                        message: '获取店铺失败，请联系管理员',
                        type: 'error'
                    });
                }
            }).catch(error => {
                console.log(error);
                this.$message({
                    message: '获取店铺异常，请联系管理员',
                    type: 'error'
                });
            });
        },
      //查询账号信息、店铺信息等。
      expand(row, expanded) {
        if(expanded) {
            this.expands = [];
            this.expands.push(row.id);
            this.getCard(row.dianpu_id);
            this.getDianpu(row.dianpu_id);
        }
      },
    },
    created() {
        this.search();
    }
}
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// tixian.vue?6ea13d71